/**
 * 공용사용 라이브러리 링크
 * @exports coreUtils => utils/coreUtils
 * @exports webUtils => utils/webUtils
 * @exports logUtils => utils/logUtils
 * @exports modelUtils => utils/modelUtils
 * @exports numberUtils => utils/numberUtils
 * @exports axiosUtils => utils/axiosUtils
 * @exports configProperties => utils/configProperties
 * @exports jsonUtils => utils/jsonUtils
 * @exports locationUtils => utils/client/locationUtils
 * @exports browserUtils => utils/client/browserUtils
 * @exports {@link env}
 * @exports {@link logger}
 * @exports {@link globalStore}
 * @packageDocumentation
 */
// #region add ts polyfill
// import 'ts-polyfill/lib/es2015-core'
// import 'ts-polyfill/lib/es2015-promise'
// import 'ts-polyfill/lib/es2015-iterable'
// import 'ts-polyfill/lib/es2016-array-include'
// import 'ts-polyfill/lib/es2017-typed-arrays'
// import 'ts-polyfill/lib/es2017-object'
// import 'ts-polyfill/lib/es2019-array'
// import 'ts-polyfill/lib/es2019-object'
// import 'ts-polyfill/lib/index'
// import 'core-js/es/array/fill'
// import 'core-js/es/typed-array/fill'

// @ts-ignore
// eslint-disable-next-line no-extend-native
// Uint8Array.prototype.fill = Array.prototype.fill

// #endregion

import * as coreUtils from './utils/core-utils'
import * as webUtils from './utils/web-utils'
import logUtils from './utils/log-utils'
import * as modelUtils from './utils/model-utils'
import * as numberUtils from './utils/number-utils'
import * as axiosUtils from './utils/axios-utils'
import * as jsonUtils from './utils/json-utils'
import * as locationUtils from './utils/client/location-utils'
import * as browserUtils from './utils/client/browser-utils'
import globalStore from './utils/global-store'
import * as env from './config/env'
import * as configProperties from './config/config-properties'
import * as propertyStore from './config/property-store'

/** @ignore */
const logger = logUtils

export { coreUtils, webUtils, env, configProperties, logUtils, modelUtils, axiosUtils, numberUtils, jsonUtils, locationUtils, browserUtils, globalStore, propertyStore, logger }

/**
 * core library base path
 * ```typescript
 * import { basePath } from '@ustra/core'
 * const path = basePath()
 * ```
 *
 * @exports basePath
 * @server
 */
// export const basePath = (): string => {
//   return __dirname
// }

export const coreLogger = logger('@ustra/core')
